module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_8003.8d810a15.png";